<template>
  <div class="leave-form-wrap">
    <!-- 顶部导航栏 -->

    <van-nav-bar right-text="历史记录" @click-right="jumpLeave">
      <template #left>
        <van-tabs
          :ellipsis="false"
          type="line"
          color="#1989FA"
          @change="changeLeaveType"
        >
          <van-tab name="0" title="本人请假"> </van-tab>
          <van-tab name="1" title="给学生请假"></van-tab>
        </van-tabs>
      </template>
    </van-nav-bar>

    <!-- 老师请假和学生请假 -->
    <template v-if="leaveType">
      <ClassLeaveForm />
    </template>
    <template v-else>
      <DeptLeaveForm />
    </template>
  </div>
</template>

<script>
// 老师给本人请假
import DeptLeaveForm from "./teacherLeaveDeptForm.vue";
// 老师给学生请假
import ClassLeaveForm from "./teacherLeaveClassForm.vue";
export default {
  data() {
    return {
      // 判断本人请假还是学生请假
      leaveType: 0, // (本人请假 0 给学生请假 1)
    };
  },
  methods: {
    // 点击切换请假模式
    changeLeaveType(e) {
      this.leaveType = Number(e);
    },
    // 跳转至请假记录
    jumpLeave() {
      if (!this.leaveType) {
        this.$router.push("/leaveList");
      } else {

        this.$router.push("/leaveListStudent");      }
    },
  },
  components: {
    DeptLeaveForm,
    ClassLeaveForm,
  },
};
</script>

<style lang="scss" scoped>
.form-wrap {
  margin: 1rem;
  box-shadow: 0 0.25rem 1rem rgba(69, 91, 99, 0.1);
  border-radius: 0.75rem;
  overflow: hidden;
}
</style>
